import { render, staticRenderFns } from "./AuditLogItemCompact.vue?vue&type=template&id=96ffd10c"
import script from "./AuditLogItemCompact.vue?vue&type=script&lang=js"
export * from "./AuditLogItemCompact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports